/** ***********
*
* <family.reducer.ts v1.0>
*
* Copyright (c) 2023 AIRBUS OPERATIONS
*
* Contributors:
*  pranshushrivastav [pranshu.shrivastav@soprasteria.com]
*  GARY Adrien (NG635E8) [adrien.gary.external@airbus.com]
*
* All rights reserved.
**************/

import {
    fetchAllFamilies,
    mappingAllFamiliesParentFamilies,
    mappingSomeFamiliesParentFamilies,
    successDeleteFamilies,
} from '../actions/family.action';
import { Family } from 'src/app/models/family';
import { Scope } from 'src/app/models/profile';
import { Action, createReducer, on } from '@ngrx/store';

export interface State {
    data: {
        families: { [id: string]: Family },
    };
    loaded: boolean;

}

const initialState: State = {
    data: {
        families: {},
    },
    loaded: false,
};

const familyReducer = createReducer(
    initialState,
    on(fetchAllFamilies, (state) => ({
        ...state,
        loaded: false,
    })),
    on(mappingAllFamiliesParentFamilies, (state, action) => {
        return {
            ...state,
            loaded: true,
            data: (() => {
                const datas = {
                    families: {}
                };
                for (const family of action.families) {
                    const parentFamily = action.parentFamilies[family.parentFamilyId];
                    family.parent_family = parentFamily;
                    if (parentFamily?.scope === Scope.OVERSIZE) {
                        family.category = parentFamily.category;
                        family.isJig = parentFamily.isJig;
                    }
                    datas.families[family.id] = family;
                }
                return datas;
            })()
        };
    }),

    on(mappingSomeFamiliesParentFamilies, (state, action) => {
        return {
            ...state,
            data: (() => {
                const datas = { ...state.data };
                for (const family of action.families) {
                    const parentFamily = action.parentFamilies[family.parentFamilyId];
                    family.parent_family = parentFamily;
                    if (parentFamily?.scope === Scope.OVERSIZE) {
                        family.category = parentFamily.category;
                        family.isJig = parentFamily.isJig;
                    }
                    datas.families[family.id] = Object.assign(datas.families[family.id] || {}, {
                        picture: undefined,
                        ...family
                    });
                }
                return datas;
            })()
        };
    }),

    on(successDeleteFamilies, (state, action) => {
        return {
            ...state,
            data: (() => {
                for (const family of action.payload) {
                    delete state.data.families[family.id];
                }
                return state.data;
            })()
        };
    })

);

export function reducer(state: State | undefined, action: Action) {
    return familyReducer(state, action);
}
